/**
 * Adds data-runway-slideover-open to body when a Runway slideover is visible.
 * Used to hide Intercom/Genesys launchers only during Runway slideovers,
 * without affecting standard modals (which also use role="dialog" aria-modal="true").
 *
 * Runway slideovers are identified by aria-labelledby="slide-over-title",
 * which is specific to the @aryeo/runway Slideover component.
 */
const RUNWAY_SLIDEOVER_SELECTOR = '[aria-labelledby="slide-over-title"]'
const BODY_ATTRIBUTE = 'data-runway-slideover-open'

function countVisibleSlideovers() {
  return document.querySelectorAll(RUNWAY_SLIDEOVER_SELECTOR).length
}

function updateBodyAttribute() {
  const count = countVisibleSlideovers()
  if (count > 0) {
    document.body.setAttribute(BODY_ATTRIBUTE, '')
  } else {
    document.body.removeAttribute(BODY_ATTRIBUTE)
  }
}

export function useRunwaySlideoverBodyAttribute() {
  const observer = new MutationObserver(updateBodyAttribute)

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })

  updateBodyAttribute()

  return () => observer.disconnect()
}
